import * as types from './action-types';

export const setSelectedDate = (data) => ({
  type: types.SET_SELECTED_DATE,
  data,
});
